import * as React from 'react';
import * as DTOS from '../../../FeralScan.dtos';
import { withTheme } from '../../../common/withTheme';
import { FilterState } from "../../../reducers/filter.reducer";
import FilterSearchContainer from "../../Filter/FilterSearchContainer";
import SampleSizeColumnChart from '../../Graphs/SampleSizeColumnChart';
import * as classNames from "classnames";

interface IPlotResultsProps {
    activePlot: DTOS.Plot;
    activePlotId: number;
    currentUser: any;
    filter: FilterState;
    plotSeasonSummaryData: DTOS.PlatypusPlotSeasonSummary[];
}

interface IPlotResultsActions {
}

type PlotResultsAllProps = IPlotResultsProps & IPlotResultsActions;

class PlotResults extends React.PureComponent<PlotResultsAllProps, any> {
    constructor(props, context) {
        super(props, context);
        this.state = { showModal: false };
    }

    render() {
        const { activePlot, currentUser, filter, plotSeasonSummaryData } = this.props;

        const graphColours = ['#A79350', '#79a750', '#a75079', '#7e50a7', '#FFC00F', '#E6A2A0', '#E4DBCF', '#CCCC00', '#D1E6B4', '#9A9663', '#7A7663'];

        const decimalSigFigs = 2;
        const minimumSampleSizeForResult = 20;

        const legend = <div className="text-right pt-3">
            <div>Numerals above bars = number of scans</div>
            <div>{`* = Insufficient Data (< ${minimumSampleSizeForResult} scans)`}</div>
        </div>

        const wrappingChartClassName = "border-primary border p-3 my-2";
        //Convert summary to graphable data
        let allYearsSummary: DTOS.PlatypusPlotSeasonSummary[] = [];
        let seasonCharts: JSX.Element[] = [];
        if (plotSeasonSummaryData && plotSeasonSummaryData.length > 0) {

            //Check for any filtering from user
            const filteredData = filter && filter.selectedClassifications && filter.selectedClassifications.value
                ? plotSeasonSummaryData.filter(d => d.timeOfDay && filter.selectedClassifications.value.filter(c => c.code == d.timeOfDay.code).length > 0)
                : plotSeasonSummaryData;

            //Iterate through each season
            filteredData.forEach(ppss => {
                const season = ppss.season;
                if (season && allYearsSummary.findIndex(ppss2 => ppss2.season && ppss2.season.code == season.code) == -1) {
                    let seasonData = filteredData.filter(ppss2 => ppss2.season && ppss2.season.code == season.code);
                    let plotEventCount = seasonData
                        .map(ppss2 => ppss2.plotEventCount)
                        .reduce((sum: number, next: number) => sum + next, 0);
                    let platypusCount = seasonData
                        .map(ppss2 => ppss2.platypusCount)
                        .reduce((sum: number, next: number) => sum + next, 0);
                    allYearsSummary.push({
                        plotId: ppss.plotId,
                        season: season,
                        timeOfDay: undefined,
                        year: undefined,
                        plotEventCount,
                        platypusCount,
                    });

                    let seasonSummary: DTOS.PlatypusPlotSeasonSummary[] = [];

                    //Iterate through each year for this season
                    seasonData.forEach(ppss2 => {
                        const year = ppss2.year;
                        if (year && seasonSummary.findIndex(ppss2 => ppss2.year && ppss2.year == year) == -1) {
                            let yearData = seasonData.filter(ppss2 => ppss2.year && ppss2.year == year);
                            let plotEventCount = yearData
                                .map(ppss2 => ppss2.plotEventCount)
                                .reduce((sum: number, next: number) => sum + next, 0);
                            let platypusCount = yearData
                                .map(ppss2 => ppss2.platypusCount)
                                .reduce((sum: number, next: number) => sum + next, 0);
                            seasonSummary.push({
                                plotId: ppss2.plotId,
                                season: season,
                                timeOfDay: undefined,
                                year: year,
                                plotEventCount,
                                platypusCount,
                            });
                        }
                    });

                    const seasonChartData = seasonSummary.map(ppss2 =>
                        [
                            ppss2.year,
                            ppss2.plotEventCount < minimumSampleSizeForResult ? "0" : (ppss2.platypusCount / ppss2.plotEventCount).toFixed(decimalSigFigs)
                        ]);

                    const sampleSizeData: number[] = seasonSummary.map(ppss2 => ppss2.plotEventCount);

                    const yScaleMax: number = seasonChartData && seasonChartData.length > 0 ? Number((seasonChartData.map(d => Number(d[1])).reduce((a, b) => Math.max(a, b)) + 0.2).toFixed(1)) : 0.5;

                    const seasonChart = <div className={classNames("col-md-5 col-11 mx-md-2", wrappingChartClassName)} key={`chart-${season.code}`}>
                        <h5>Average Sightings/Scan in  {season.code[0].toUpperCase() + season.code.substring(1, season.code.length).toLowerCase()}</h5>
                        <SampleSizeColumnChart
                            colors={graphColours}
                            data={seasonChartData}
                            legend={false}
                            sampleSizeData={sampleSizeData}
                            sampleSizeMinimumForResult={minimumSampleSizeForResult}
                            sampleSizeZeroText={'*'}
                            yLabel={'Average Sightings/scan'}
                            yLabelHover={'Average Sightings/Scan'}
                            yScaleMax={yScaleMax}
                        />
                        {legend}
                    </div>

                    seasonCharts.push(seasonChart);
                }
            });
        }

        const allYearsChartData = allYearsSummary.map(ppss =>
            [
                ppss.season.code,
                ppss.plotEventCount < minimumSampleSizeForResult
                    ? "0"
                    : (ppss.platypusCount / ppss.plotEventCount).toFixed(decimalSigFigs)
            ]);

        const allYearsSampleSizes: number[] = allYearsSummary.map(ppss => ppss.plotEventCount);

        const yScaleMax: number = allYearsChartData && allYearsChartData.length > 0 ? Number((allYearsChartData.map(d => Number(d[1])).reduce((a, b) => Math.max(a, b)) + 0.2).toFixed(1)) : 0.5;

        return (
            activePlot ?
                <div>
                    <div className="col-12 col-xl-6">
                        <FilterSearchContainer
                            classificationFilter={undefined}
                            currentUser={currentUser}
                            onFilterChanged={undefined}
                            showFilters={true}
                            show={true}
                        />
                    </div>
                    <div className="row justify-content-center no-gutters">
                        <div className={classNames("col-md-8 col-11", wrappingChartClassName)}>
                            <h5>How Sightings Vary by Season</h5>
                            <SampleSizeColumnChart
                                colors={graphColours}
                                data={allYearsChartData}
                                legend={false}
                                sampleSizeData={allYearsSampleSizes}
                                sampleSizeMinimumForResult={minimumSampleSizeForResult}
                                sampleSizeZeroText={'*'}
                                yLabel={'average sightings/scan'}
                                yLabelHover={'Average Sightings per Scan'}
                                yScaleMax={yScaleMax}
                            />
                            {legend}
                        </div>
                        {seasonCharts}
                    </div>
                </div> : <div>NO RESULTS</div>
        );
    }
}

export default withTheme<PlotResultsAllProps>(PlotResults);